import {
  GET_HYPERLINK_BY_ID_REQUESTED,
  GET_HYPERLINK_BY_ID_FAILED,
  GET_HYPERLINK_BY_ID_SUCCESS,
  ADD_NEW_HYPERLINK_REQUESTED,
  ADD_NEW_HYPERLINK_FAILED,
  ADD_NEW_HYPERLINK_SUCCESS,
  CLEAR_HYPERLINK,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const hyperlinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HYPERLINK_BY_ID_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_HYPERLINK_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_HYPERLINK_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case ADD_NEW_HYPERLINK_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_HYPERLINK_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case ADD_NEW_HYPERLINK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_HYPERLINK:
      return initialState;
    default:
      return state;
  }
};

export default hyperlinkReducer;
